import {
  UPDATE_ASSETS_AND_NET_WORTH_INFO,
  UPDATE_LIABILITIES_NET_WORTH_INFO,
} from '../actions/actionTypes';

import {
  ASSETS,
  SAVINGS_ACCOUNT,
  CHECKING_ACCOUNT,
  INVESTMENTS,
  LIFE_INSURANCE_POLICY,
  PENSION_EQUITY,
  PROFIT_SHARING_EQUITY,
  EMPLOYER_SHARING_PLAN,
  RETIREMENT_FUND,
  REAL_ESTATE,
  OTHER,
  TOTAL_ASSETS,
  LIABILITIES,
  CREDIT_CARD_BILLS,
  UNPAID_MEDICAL_DENTAL_BILL,
  MORTGAGE_BALANCE,
  HOME_EQUITY_LOANS,
  PENSION_LOANS,
  CAR_LOANS,
  UNPAID_TAXES,
  TOTAL_LIABILITIES,
  NET_WORTH,
  savingsAccount,
  checkingsAccount,
  investmentAttribute,
  lifeInsurancePolicy,
  pensionEquity,
  profitSharingEquity,
  employerSharingPlan,
  retirementFund,
  realEstate,
  other,
  total,
  unpaidMedicalDentalBill,
  mortgageBalance,
  homeEquityLoan,
  pensionLoan,
  carLoan,
  unpaidTax,
  creditCardBill,
} from '../constants/Dashboard/Asset-NetWorth';

const DEFAULT_STATE = {
  [ASSETS]: {
    [SAVINGS_ACCOUNT]: '',
    [CHECKING_ACCOUNT]: '',
    [INVESTMENTS]: '',
    [LIFE_INSURANCE_POLICY]: '',
    [PENSION_EQUITY]: '',
    [PROFIT_SHARING_EQUITY]: '',
    [EMPLOYER_SHARING_PLAN]: '',
    [RETIREMENT_FUND]: '',
    [REAL_ESTATE]: '',
    [OTHER]: '',
    [TOTAL_ASSETS]: 0,
  },
  [LIABILITIES]: {
    [CREDIT_CARD_BILLS]: '',
    [UNPAID_MEDICAL_DENTAL_BILL]: '',
    [MORTGAGE_BALANCE]: '',
    [HOME_EQUITY_LOANS]: '',
    [PENSION_LOANS]: '',
    [CAR_LOANS]: '',
    [UNPAID_TAXES]: '',
    [OTHER]: '',
    [TOTAL_LIABILITIES]: 0,
  },
  [NET_WORTH]: {
    [ASSETS]: 0,
    [LIABILITIES]: 0,
    [NET_WORTH]: 0,
  },
};

export const assetsAndNetWorthReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case UPDATE_ASSETS_AND_NET_WORTH_INFO:
      return {
        ...state,
        [ASSETS]: {
          [SAVINGS_ACCOUNT]: action.payload[savingsAccount],
          [CHECKING_ACCOUNT]: action.payload[checkingsAccount],
          [INVESTMENTS]: action.payload[investmentAttribute],
          [LIFE_INSURANCE_POLICY]: action.payload[lifeInsurancePolicy],
          [PENSION_EQUITY]: action.payload[pensionEquity],
          [PROFIT_SHARING_EQUITY]: action.payload[profitSharingEquity],
          [EMPLOYER_SHARING_PLAN]: action.payload[employerSharingPlan],
          [RETIREMENT_FUND]: action.payload[retirementFund],
          [REAL_ESTATE]: action.payload[realEstate],
          [OTHER]: action.payload[other],
          [TOTAL_ASSETS]: action.payload[total],
          id: action.payload?.id,
        },
        [NET_WORTH]: {
          ...state[NET_WORTH],
          [ASSETS]: action.payload[total],
          [NET_WORTH]: action.payload[total] - state[NET_WORTH][LIABILITIES],
        },
      };

    case UPDATE_LIABILITIES_NET_WORTH_INFO:
      return {
        ...state,
        [LIABILITIES]: {
          [CREDIT_CARD_BILLS]: action.payload[creditCardBill],
          [UNPAID_MEDICAL_DENTAL_BILL]: action.payload[unpaidMedicalDentalBill],
          [MORTGAGE_BALANCE]: action.payload[mortgageBalance],
          [HOME_EQUITY_LOANS]: action.payload[homeEquityLoan],
          [PENSION_LOANS]: action.payload[pensionLoan],
          [CAR_LOANS]: action.payload[carLoan],
          [UNPAID_TAXES]: action.payload[unpaidTax],
          [OTHER]: action.payload[other],
          [TOTAL_LIABILITIES]: action.payload[total],
          id: action.payload?.id,
        },
        [NET_WORTH]: {
          ...state[NET_WORTH],
          [LIABILITIES]: action.payload[total],
          [NET_WORTH]: state[ASSETS] - state[NET_WORTH][LIABILITIES],
        },
      };

    default:
      return {
        ...state,
      };
  }
};
